<template>
  <div
    :class="'main-share ' + (absolute ? 'main-share-absolute' : '')"
    :style="color
      ? 'justify-content: left; margin: 0;'
      : ''"
  >
		<b
      :style="color
        ? 'color: ' + color +';'
        : ''"
    >Share:</b>
		<a
      :style="color ? 'color: ' + color +';' : ''"
      :href="'http://twitter.com/share?text=Costasolrent.com - &amp;url=' + siteLink"
      class="twitter popup" target="_blank"
    >
      <i class="fab fa-twitter-square"></i>
    </a>
		<a
      :style="color ? 'color: ' + color +';' : ''"
      :href="'http://www.facebook.com/share.php?u=' + siteLink" class="facebook popup" target="_blank"
    >
      <i class="fab fa-facebook-square"></i>
    </a>
		<a
      :style="color ? 'color: ' + color +';' : ''"
      :href="'https://plus.google.com/share?url=' + siteLink" class="google popup" target="_blank">
      <i class="fab fa-google-plus-square"></i>
    </a>
		<a
      :style="color ? 'color: ' + color +';' : ''"
      :href="'https://www.linkedin.com/shareArticle?mini=true&amp;url=' + siteLink" class="popup" target="_blank">
      <i class="fab fa-linkedin"></i>
    </a>
		<a
      :style="color ? 'color: ' + color +';' : ''"
      :href="'whatsapp://send?text=' + siteLink" class="popup" target="_blank">
      <i class="fab fa-whatsapp-square"></i>
    </a>
		<a
      v-if="!color"
      :style="color ? 'color: ' + color +';' : ''"
      href="javascript:void(0)" class="share-email-option" @click="showEmailModal = true">
      <i class="fas fa-envelope-square"></i>
    </a>
  </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields'
import state from './../state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'MainShare',

  props: {
    color: {
      type: String,
      default: null
    },
    absolute: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapFields(Object.keys(state)),

    siteLink () {
      return window.location.origin + this.$route.fullPath
    }
  }
}
</script>

<style>
img.share-logo {
    vertical-align: middle;
    margin-left: 4px;
}
.main-share {
  color: gray;
  height: 40px;
  margin: 10px 0 10px 0;
  width: 100%;
  line-height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.main-share-absolute {
  position: absolute;
  top: -8px;
  right: 0;
  margin: 0 10px 0 0;
  width: auto;
}
.main-share a {
  color: grey;
  padding: 5px 0px 5px 9px;
  font-size: 26px;
}
</style>
